import styles from "./Input.module.css";

function Input({ type, text, name, placeholder, handleOnChange, icon, ...rest }) {
  return (
    <div className={styles.itensform}>
      {icon && <span className={styles.inputIcon}>{icon}</span>}
      <input
        type={type}
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={handleOnChange}
        className={icon ? styles.inputWithIcon : ''}
        {...rest} // repassa data-cy e outros atributos
      />
    </div>
  );
}

export default Input;
